<template>
  <ReactSiteFrame :src="src" />
</template>
<script>
import ReactSiteFrame from '../components/react/iframe'

export default {
  name: 'SuggestionsReact',
  components: {
    ReactSiteFrame
  },
  data() {
    return {
      src: '/view/suggestions'
    }
  }
}
</script>
